import Button from "@mui/material/Button";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";

const CardForm = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async () => {
    const result = await stripe!.confirmPayment({
      //@ts-ignore
      elements,
      confirmParams:{
        return_url:'https://rq-foodprint.flying-foot.com/thanks'
      }
    });
    console.log(result)
  };
  return (
    <form>
      <PaymentElement />
      <Button onClick={handleSubmit}>決済を実行する</Button>
    </form>
  );
};
export default CardForm;
